export default __webpack_public_path__ + "static/how-to-pick-the-right-credit-card-for-your-travel-phone-bridge-f607609718f0407c061fe600c21768c3.jpg";